import {SvgIconName} from '@shipwell/shipwell-ui';
import {AppointmentStatusEnum, ReferenceQualifierEnum} from '@shipwell/tempus-sdk';

export const FULL_CALENDAR_LICENSE_KEY = '0131036235-fcs-1667843563';
export const BigCalendarAllDayEventClass = 'sw-all-day-event';
export const BigCalendarCurrentDateTimeId = 'BigCalendarCurrentDateTimeId';

export const FacilityAppointmentResourceId = '000_AAA_FacilityAppointmentsResourceId';
export const FacilityAppointmentResourceName = 'Facility Appointments';

// eslint-disable-next-line @typescript-eslint/require-await, @typescript-eslint/no-explicit-any
export const InitAppointmentCallback = async (...args: any[]) => {
  console.log('NOOP', {args});
};

export const DocklessEventColor = '#a8a8a8';
export const DefaultAppointmentDurationMinutes = 60;

export const StatusToColor: Record<AppointmentStatusEnum, string> = {
  [AppointmentStatusEnum.Arrived]: '#e8f2eb',
  [AppointmentStatusEnum.ArrivedLate]: '#f7e8e7',
  [AppointmentStatusEnum.Unscheduled]: '#ffffff',
  [AppointmentStatusEnum.Cancelled]: '#f7e8e7',
  [AppointmentStatusEnum.Completed]: '#f5f5f5',
  [AppointmentStatusEnum.Delayed]: '#fcf4e6',
  [AppointmentStatusEnum.NoShow]: '#f7e8e7',
  [AppointmentStatusEnum.Rejected]: '#f7e8e7',
  [AppointmentStatusEnum.Scheduled]: '#e7f1fb',
  [AppointmentStatusEnum.Rescheduled]: '#e7f1fb',
  [AppointmentStatusEnum.DockInUse]: 'rgb(247, 236, 217)',
  [AppointmentStatusEnum.DockIsReady]: 'rgb(217, 229, 219)'
};

export const SvgIconColors: Record<AppointmentStatusEnum, string> = {
  [AppointmentStatusEnum.Arrived]: '#1B7B3B', // green goblin
  [AppointmentStatusEnum.ArrivedLate]: '#B41D13', // red alert
  [AppointmentStatusEnum.Cancelled]: '#58595B', // gray #5
  [AppointmentStatusEnum.Completed]: '#58595B', // gray #5
  [AppointmentStatusEnum.NoShow]: '#B41D13', // red alert
  [AppointmentStatusEnum.Scheduled]: '#0A6FDB', // blue man crew
  [AppointmentStatusEnum.Rescheduled]: '#0A6FDB', // blue man crew
  [AppointmentStatusEnum.Unscheduled]: '#58595B', // gray #5
  [AppointmentStatusEnum.Rejected]: '#B41D13',

  [AppointmentStatusEnum.Delayed]: '#DF9100',
  [AppointmentStatusEnum.DockInUse]: '#DF9100',
  [AppointmentStatusEnum.DockIsReady]: '#1B7B3B'
};

export const SvgIconNames: Record<AppointmentStatusEnum, SvgIconName> = {
  [AppointmentStatusEnum.Arrived]: 'Time',
  [AppointmentStatusEnum.ArrivedLate]: 'TimeMissing',
  [AppointmentStatusEnum.Cancelled]: 'CalendarCancelled',
  [AppointmentStatusEnum.Completed]: 'CheckCircleFilled',
  [AppointmentStatusEnum.NoShow]: 'ErrorOutlined',
  [AppointmentStatusEnum.Scheduled]: 'Calendar',
  [AppointmentStatusEnum.Rescheduled]: 'Calendar',
  [AppointmentStatusEnum.Unscheduled]: 'UnplannedTime',
  [AppointmentStatusEnum.Rejected]: 'ThumbsDown',
  [AppointmentStatusEnum.Delayed]: 'CalendarCancelled',
  [AppointmentStatusEnum.DockInUse]: 'CalendarCancelled',
  [AppointmentStatusEnum.DockIsReady]: 'CalendarCheck'
};

export const StatusTexts: Record<AppointmentStatusEnum, string> = {
  [AppointmentStatusEnum.Arrived]: 'Arrived',
  [AppointmentStatusEnum.ArrivedLate]: 'ArrivedLate',
  [AppointmentStatusEnum.Cancelled]: 'Cancelled',
  [AppointmentStatusEnum.Completed]: 'Complete',
  [AppointmentStatusEnum.NoShow]: 'No Show',
  [AppointmentStatusEnum.Scheduled]: 'Scheduled',
  [AppointmentStatusEnum.Rescheduled]: 'Rescheduled',
  [AppointmentStatusEnum.Unscheduled]: 'Unscheduled',
  [AppointmentStatusEnum.Rejected]: 'Rejected',
  [AppointmentStatusEnum.Delayed]: 'Delayed',

  [AppointmentStatusEnum.DockInUse]: 'Dock Occupied',
  [AppointmentStatusEnum.DockIsReady]: 'Dock Is Ready'
};

export const ReferenceAbbreviatedLabels: Record<ReferenceQualifierEnum, string> = {
  [ReferenceQualifierEnum.PoNumber]: 'PO#',
  [ReferenceQualifierEnum.BolNumber]: 'BOL#',
  [ReferenceQualifierEnum.CustomerReferenceNumber]: 'Customer Ref#',
  [ReferenceQualifierEnum.ProNumber]: 'PRO#',
  [ReferenceQualifierEnum.ShipmentReferenceId]: 'Shipment Ref#'
};

export const ReferencePreferenceOrder = [
  ReferenceQualifierEnum.PoNumber,
  ReferenceQualifierEnum.CustomerReferenceNumber,
  ReferenceQualifierEnum.ProNumber,
  ReferenceQualifierEnum.ShipmentReferenceId,
  ReferenceQualifierEnum.BolNumber
];

export const ReferenceQualifierNames: Record<ReferenceQualifierEnum, string> = {
  [ReferenceQualifierEnum.PoNumber]: 'Purchase Order',
  [ReferenceQualifierEnum.BolNumber]: 'Bill of Lading',
  [ReferenceQualifierEnum.CustomerReferenceNumber]: 'Customer Reference',
  [ReferenceQualifierEnum.ProNumber]: 'PRO',
  [ReferenceQualifierEnum.ShipmentReferenceId]: 'Shipment'
};
